import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=069ef02a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=069ef02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ef02a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069ef02a')) {
      api.createRecord('069ef02a', component.options)
    } else {
      api.reload('069ef02a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=069ef02a&scoped=true&", function () {
      api.rerender('069ef02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oJlRPI3sm3bi/JS/comp/CookieBox.vue"
export default component.exports